export const enFeedbackLocale = {
  give_feedback_button: 'Give Feedback',
  give_feedback_drawer_title: 'Feedback',
  give_feedback_drawer_content: "We'd love to hear your feedback!",
  give_feedback_drawer_cancel_button: 'Cancel',
  general_feedback_question:
    "Reading Critters is in early development, and we'd love to hear your feedback. Is there anything you'd like to tell us about your experience using the app?",
  general_feedback_response:
    "Thank you. We are working hard to make Reading Critters the best early reading app in the world, so your feedback is appreciated. If you want to share anything else with us in the future, please don't hesitate to do so!",
  lesson_end_feedback_enjoyment_question:
    "You've been so helpful freeing me! I wonder, are you enjoying doing these reading tasks?",
  lesson_end_feedback_difficulty_question:
    'Thank you for sharing! Are there any things you find difficult or frustrating about doing these tasks?',
  lesson_end_feedback_other_question:
    'OK, got it. Are there any other things you want to tell me about your experience in Reeding Critters?',
  lesson_end_feedback_response:
    'Understood. Thank you so much for sharing your thoughts with me! I really appreciate it, and will use them to try and make Reeding Critters even more fun. Tap the Ball to start freeing the next Reeding Critter.',
};
